import axios from "axios";

export const state = {
    staff: [],
    delivery_staff: [],
    positions: [],
    payroll:[],
    monthly_staff_salaries:[],
    save_status: false,
    filter_status: false,
    staff_salaries: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 10,
            to: 0,
            total: 0,
        },
        isServerPaginated: false,
        
    },
    salary_advances: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 10,
            to: 0,
            total: 0,
        },
        isServerPaginated: false,
        
    },
    staff_allowances: {
        data: [],
        meta: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 10,
            to: 0,
            total: 0,
        },
        isServerPaginated: false,
        
    },
};
export const getters = {
    Staff: state => state.staff.data,
    DeliveryStaff: state => state.delivery_staff.data,
    StaffPositions: state => state.positions.data,
    StaffPayroll: state => state.payroll.data,
    StaffAdvances: state => state.salary_advances.data,
    StaffAdvancesPagination: state => state.salary_advances.meta,
    StaffAdvancesPaginated: state => state.salary_advances.data,
    IsAdvancesServerPaginated: state => state.salary_advances.isServerPaginated,
    StaffAllowances: state => state.staff_allowances.data,
    StaffAllowancesPagination: state => state.staff_allowances.meta,
    IsAllowancesServerPaginated: state => state.staff_allowances.isServerPaginated,
    StaffSalaries: state => state.staff_salaries.data,
    StaffSalariesPagination: state => state.staff_salaries.meta,
    IsSalariesServerPaginated: state => state.staff_salaries.isServerPaginated,
    MonthlyStaffSalaries: state => state.monthly_staff_salaries.data,
    MonthlyStaffSalariesPagination: state => state.monthly_staff_salaries.meta,
    IsMonthlyStaffSalariesServerPaginated: state => state.monthly_staff_salaries.isServerPaginated,
    MonthlyStaffSalariesPaginated: state => state.monthly_staff_salaries.data,

    StaffSave: state => state.save_status,
    filterStatus: state => state.filter_status,

};
export const mutations = {
    SET_STAFF(state, newValue) {
        state.staff = newValue
    },

    SET_DELIVERY_STAFF(state, newValue) {
        state.delivery_staff = newValue
    },

    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },

    SET_STAFF_POSITION(state, newValue) {
        state.positions = newValue
    },

    SET_STAFF_PAYROLL(state, newValue) {
        state.payroll = newValue
    },

    SET_STAFF_ADVANCES(state, response) {
        // state.salary_advances = newValue
         if (response && response.data) {
            state.salary_advances.data = response.data;

            if (response.meta && response.links) {
                state.salary_advances.meta = response.meta;
                state.salary_advances.isServerPaginated = true;
            } else {
                state.salary_advances.meta = {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: response.data.length ||10,
                    to: response.data.length || 0,
                    total: response.data.length || 0,
                };
                state.salary_advances.isServerPaginated = false;
            }
        } else {
            state.salary_advances.data = [];
            state.salary_advances.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
            state.salary_advances.isServerPaginated = false;
        }
    },

    SET_STAFF_ALLOWANCES(state, response) {
        // state.staff_allowances = newValue
         if (response && response.data) {
            state.staff_allowances.data = response.data;

            if (response.meta && response.links) {
                state.staff_allowances.meta = response.meta;
                state.staff_allowances.isServerPaginated = true;
            } else {
                state.staff_allowances.meta = {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: response.data.length ||10,
                    to: response.data.length || 0,
                    total: response.data.length || 0,
                };
                state.staff_allowances.isServerPaginated = false;
            }
        } else {
            state.staff_allowances.data = [];
            state.staff_allowances.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
            state.staff_allowances.isServerPaginated = false;
        }
    },

    SET_STAFF_SALARIES(state, response) {
        if (response && response.data) {
            state.staff_salaries.data = response.data;

            if (response.meta && response.links) {
                state.staff_salaries.meta = response.meta;
                state.staff_salaries.isServerPaginated = true;
            } else {
                state.staff_salaries.meta = {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: response.data.length ||10,
                    to: response.data.length || 0,
                    total: response.data.length || 0,
                };
                state.staff_salaries.isServerPaginated = false;
            }
        } else {
            state.staff_salaries.data = [];
            state.staff_salaries.meta = { current_page: 1, from: 1, last_page: 1, per_page: 10, to: 0, total: 0 };
            state.staff_salaries.isServerPaginated = false;
        }
    },

    SET_MONTHLY_STAFF_SALARIES(state, newValue) {
        state.monthly_staff_salaries = newValue
    },

    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },

    CLEAR_STAFF_SALARIES(state){
    state.staff_salaries.data = [];
    },

    CLEAR_MONTHLY_STAFF_SALARIES(state){
    state.monthly_staff_salaries = [];
    },

    CLEAR_STAFF_ADVANCES(state){
    state.salary_advances.data = [];
    },

    CLEAR_STAFF_ALLOWANCES(state){
    state.staff_allowances.data = [];
    }
};
export const actions = {
    addStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff', payload).then(() => {
            dispatch('fetchAllStaff');
            dispatch('fetchStaff');
            let message = { 'msg': ` Staff added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff " }
            dispatch('notification/error', message, { root: true })
        })
    },
    deleteStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff/${payload.id}`).then(() => {
            dispatch('fetchStaff');
            let message = { 'msg': `Staff  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Staff
    editStaff({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff/${payload.id}`, payload).then(() => {
            dispatch('fetchAllStaff');
            let message = { 'msg': `Details of Staff ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Staff
    fetchStaff({ commit }) {
        axios.get('staff').then(ec_res => {
            commit('SET_DELIVERY_STAFF', ec_res.data)
        })
    },

    fetchAllStaff({ commit }) {
        axios.get('all_staff').then(ec_res => {
            commit('SET_STAFF', ec_res.data)
        })
    },

    addStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_position', payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': ` Staff position added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff " }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_position/${payload.id}`).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': `Staff position record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    
    // Edit Staff
    editStaffPosition({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_position/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffPositions');
            let message = { 'msg': `Details of Staff position ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff position Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Fetch Staff

    fetchStaffPositions({ commit }) {
        axios.get('staff_position').then(ec_res => {
            commit('SET_STAFF_POSITION', ec_res.data)
        })
    },

    // Staff Payroll
    addStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_payroll', payload).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': ` Staff enrolled to payroll successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff Payroll" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Payroll
    deleteStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_payroll/${payload.id}`).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': `Staff payroll record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Payroll
    editStaffPayroll({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_payroll/${payload.id}`, payload).then(() => {
            dispatch('fetchStaffPayroll');
            let message = { 'msg': `Payroll details for ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff payroll Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Payroll
    fetchStaffPayroll({ commit }) {
        axios.get('staff_payroll').then(ec_res => {
            commit('SET_STAFF_PAYROLL', ec_res.data)
        })
    },


    // Staff advances
    addStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('salary_advances', payload).then(() => {
            let message = { 'msg': `Staff advance added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Staff advance" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Advance
    deleteStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`salary_advances/${payload.id}`).then(() => {
            dispatch('fetchStaffAdvances');
            let message = { 'msg': `Staff advance record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Advance
    editStaffAdvance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`salary_advances/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Details of Staff advance ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff advance Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Advances
    fetchStaffAdvances({ commit, dispatch }, payload = {}) {
        commit('CLEAR_STAFF_ADVANCES');
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page ||10;
        apiPayload.datefrom = payload.datefrom || '';
        apiPayload.dateto = payload.dateto || '';
        apiPayload.staff_id = payload.staff_id || '';

        axios.get('salary_advances', { params: apiPayload })
        .then(response => {
            commit('SET_STAFF_ADVANCES', response.data);
            commit('SET_FILTER_STATUS', false);
        })
        .catch(() => {
            commit('SET_STAFF_ADVANCES', { 
                data: [], 
                meta:{}, 
               
            });
            commit('SET_FILTER_STATUS', false);
            dispatch('notification/error', { msg: 'Failed to load staff advances.' }, { root: true });
        });
    },


    // Staff allowances
    addStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_allowances', payload).then(() => {
            let message = { 'msg': `Staff allowance payment recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Recording Staff allowance payment" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Allowance
    deleteStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_allowances/${payload.id}`).then(() => {
            let message = { 'msg': `Staff allowance record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Allowance
    editStaffAllowance({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_allowances/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Details of Staff allowance for ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff allowance Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Allowances
    fetchStaffAllowances({ commit, dispatch }, payload={}) {
        commit('CLEAR_STAFF_ALLOWANCES');
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page ||10;
        apiPayload.datefrom = payload.datefrom || '';
        apiPayload.dateto = payload.dateto || '';
        apiPayload.staff_id = payload.staff_id || '';

        axios.get('staff_allowances', { params: apiPayload })
        .then(response => {
            commit('SET_STAFF_ALLOWANCES', response.data);
            commit('SET_FILTER_STATUS', false);
        })
        .catch(() => {
            commit('SET_STAFF_ALLOWANCES', { 
                data: [], 
                meta:{}, 
               
            });
            commit('SET_FILTER_STATUS', false);
            dispatch('notification/error', { msg: 'Failed to load staff allowances.' }, { root: true });
        });
    },

    // Staff Salaries
    addStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('staff_salaries', payload).then(() => {
            let message = { 'msg': `Staff salary payment recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Recording Staff salary payment" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Delete Staff Salary
    deleteStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`staff_salaries/${payload.id}`).then(() => {
            let message = { 'msg': `Staff salary payment record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Staff Salary
    editStaffSalary({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`staff_salaries/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Details of Staff salary payment for ${payload.staff} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Staff salary payment Details " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Staff Salaries
    fetchStaffSalaries({ commit, dispatch }, payload = {}) {
        commit('CLEAR_STAFF_SALARIES'); 
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page || 10;
        apiPayload.datefrom = payload.datefrom || '';
        apiPayload.dateto = payload.dateto || '';
        apiPayload.staff_id = payload.staff_id || '';

        axios.get('staff_salaries', { params: apiPayload })
        .then(response => {
            commit('SET_STAFF_SALARIES', response.data);
            commit('SET_FILTER_STATUS', false);
        })
        .catch(() => {
            commit('SET_STAFF_SALARIES', { 
                data: [], 
                meta:{}, 
               
            });
            commit('SET_FILTER_STATUS', false);
            dispatch('notification/error', { msg: 'Failed to load staff salaries.' }, { root: true });
        });
    },

     fetchMonthlyStaffSalaries({ commit, dispatch }, payload = {}) {
        commit('CLEAR_MONTHLY_STAFF_SALARIES');
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page || 10;
        apiPayload.staff_id = payload.staff_id || '';

        axios.get('monthly_staff_salaries', { params: apiPayload })
        .then(response => {
            commit('SET_MONTHLY_STAFF_SALARIES', response.data);
            commit('SET_FILTER_STATUS', false);
        })
        .catch(() => {
            commit('SET_MONTHLY_STAFF_SALARIES', { 
                data: [], 
                meta:{}, 
               
            });
            commit('SET_FILTER_STATUS', false);
            dispatch('notification/error', { msg: 'Failed to load staff salaries.' }, { root: true });
        });
    },

};